import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard.vue'
import Company from '../views/Company.vue'
import CreateCompany from '../views/CreateCompany.vue'
import MyCallbacks from '../views/MyCallbacks.vue'
import RecievedCallTransfer from '../views/RecieveCallTransfer.vue'
import AdminSearch from '../views/AdminSearch.vue'
import Search from '../views/Search.vue'
import AdminCallback from '../views/AdminCallback.vue'
import Unbooked from '../views/Unbooked.vue'
import DataSelection from '../views/DataSelection.vue'
import CallCampaign from '../views/CallCampaign.vue'
import CallNext from '../views/CallNext.vue'
import Auth from '../views/Auth.vue'
import MFA from '../views/MFA.vue'
import { DateTime } from 'luxon'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/dashboard', // Redirect to named route
    children: [{
      path: 'dashboard',
      component: Dashboard,
      name: 'Dashboard'
    }, {
      path: 'company/:companyId',
      component: Company,
      name: 'Company'
    },
    {
      path: 'company/:companyId/call',
      component: Company,
      name: 'CompanyCall'
    },
    {
      path: 'call/:companyId',
      component: CallNext,
      name: 'CallNext'
    }, {
      path: 'createcompany',
      component: CreateCompany,
      name: 'CreateCompany'
    }, {
      path: 'mycallbacks',
      component: MyCallbacks,
      name: 'MyCallbacks'
    }, {
      path: 'recievedtransfer',
      component: RecievedCallTransfer,
      name: 'RecievedCallTransfer'
    }, {
      path: 'unbooked',
      component: Unbooked,
      name: 'Unbooked'
    }, {
      path: 'search',
      component: Search,
      name: 'Search'
    }, {
      path: 'adminsearch',
      component: AdminSearch,
      name: 'Admin Search'
    }, {
      path: 'dataselection',
      component: DataSelection,
      name: 'Data Selection'
    }, {
      path: 'getnext',
      component: CallCampaign,
      name: 'Call Campaign'
    }, {
      path: '/auth/sso/:userId/:token',
      name: 'SSO',
      component: Auth
    }, {
      path: '/auth/sso/:userId/:token/:companyId',
      name: 'CompanySSO',
      component: Auth
      }, {
      path: 'admincallback',
      component: AdminCallback,
      name: 'AdminCallback'
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Auth
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Auth
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/MFA',
    name: 'MFA',
    component: MFA
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {

  const publicPages = ['/login', '/logout', '/auth/sso'];
  const user = localStorage.getItem('user');
  const loggedIn = (user != null)

  var tokenExpired = false;
  if (user != null) {
    if (DateTime.fromISO(JSON.parse(user).expires_in) < DateTime.utc().ts) {
      tokenExpired = true;
    }
  }
  if (publicPages.includes(to.path) || to.path.startsWith('/auth/sso') || to.path.startsWith('/MFA')) {

    if (to.path === '/logout') {
      next(); // Allow our logout attempt through
    }
    else if (to.path === '/MFA') {
      next();
    }
    else {
      // We've probably hard-refreshed, grabbed our token from localStorage and redirected to the login page
      if (loggedIn && !tokenExpired && !to.path.startsWith('/auth/sso')) {
        next('/dashboard');
      }
      else {
        next();
      }
    }
  }
  else if (!loggedIn || tokenExpired) {
    next('/login');
  }
  else {
    next();
  }
});

export default router
